var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('v-app',[_c('Navigation',{attrs:{"loggedIn":_vm.loggedIn,"poolRead":_vm.poolRead,"poolGroupRead":_vm.poolGroupRead,"userRead":_vm.userRead,"roleRead":_vm.roleRead,"protocolRead":_vm.protocolRead,"settingRead":_vm.settingRead,"username":_vm.username,"name":_vm.name}}),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b254a45","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 